import { InjectionToken } from '@angular/core';
import { environment } from '@env/environment';

export const MAPBOX_TOKEN = new InjectionToken<string>('MAPBOX_TOKEN', {
  providedIn: 'root',
  factory: () => environment.mapboxToken
});
